import React, { Component } from "react";
import { isEmpty } from "../Helper/gm";
import getGAevent from "../partners/lib/getGAevent";
import findActiveMenu from "../Helper/findActiveMenu";

class B2bGnbCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gnb_menu: this.props.gnb_menu,
      active_menu: "",
      parent_category: "",
      check_cases: {
        target: '.b2b_category .link_group li a',
        set_class: "active"
      },
    };
  }
  componentDidMount() {
    document.addEventListener("click", this.closeMenuGnbList.bind(this), false);
    /* gnb active */
    if (!window.location.href.includes('/partners/access_error')) {
      findActiveMenu(this.state.check_cases);
    }
  
    /* only one menu */
    const onlyOneMenu = this.props.gnb_menu.find(({children}) => isEmpty(children));
    
    if(!onlyOneMenu) return;
    if(window.location.href.indexOf(onlyOneMenu.link.split('/partners/')[1]) >= 0){
      document.querySelector(`.${onlyOneMenu.code}`).classList.add(this.state.check_cases.set_class);
    }
  }
  myMainMenuAction(target) {
    this.setState({
      active_menu: target,
    });
  }
  closeMenuGnbList() {
    this.myMainMenuAction("");
  }
  renderGnbList(list, depth) {
    return list.map((v, index) => {
      const ga_action = `GNB_${v.text}`;
      return (
        <li
          key={index}
          className={`ct_dp${depth} ${v.code} ${
            this.state.active_menu === v.text ? "show" : ""
          }`}
        >
          <a
            className="ct_link"
            href={v.link}
            onFocus={() => {
              this.myMainMenuAction(v.text);
            }}
            onBlur={() => {
              if (v.children.length === 0) {
                this.closeMenuGnbList();
              }
            }}
            onClick={() => {
              getGAevent({
                action: ga_action,
                label: "index"
              })
            }}
          >
            {v.text}
            {v.level === "new" ? <span className="label_new" /> : ""}
          </a>
          {v.children.length > 0 ? (
            <div className="jply_linkpanel ct_dp2" tabIndex="-1">
              <ul className="link_group">
                {this.renderSecondDepth(v.children, depth + 1, index, v.code, ga_action)}
              </ul>
            </div>
          ) : (
            ""
          )}
        </li>
      );
    });
  }
  renderSecondDepth(list, depth, mindex, code, ga_action) {
    var last_index = list.length - 1;
    return list.map((v, index) => {
      return (
        <li key={mindex + "_" + index}>
          <a
            href={v.link}
            onBlur={() => {
              if (last_index === index) {
                this.closeMenuGnbList();
              }
            }}
            onClick={() => {
              getGAevent({
                action: ga_action,
                label: v.text
              })
            }}
            data-id={code}
            target={(v.text === "채용공고 등록" && this.props.user.is_admin === false) ? "_blank" : "_self"}
          >
            {v.text}
            {v.level === "admin" ? (
              <span className="b2b_badge_admin">admin</span>
            ) : (
              ""
            )}
          </a>
        </li>
      );
    });
  }

  render() {
    if (isEmpty(this.state.gnb_menu)) return false;
    return (
      <ul
        className="b2b_category"
        onMouseOver={() => {
          this.props.over_event();
        }}
      >
        {this.renderGnbList(this.state.gnb_menu, 1)}
      </ul>
    );
  }
}

export default React.memo(B2bGnbCategory);
